import { Component, inject } from '@angular/core';
import { TablerIconComponent } from 'angular-tabler-icons';
import { PulseLoaderComponent } from 'src/app/shared/components/pulse-loader/pulse-loader.component';
import { SignItConnectionFlowService } from 'src/app/shared/services/signit-connection-flow/signit-connection-flow.service';

@Component({
	selector: 'app-sign-it-loader-modal',
	templateUrl: './sign-it-loader-modal.component.html',
	imports: [PulseLoaderComponent, TablerIconComponent],
})
export class SignItLoaderModalComponent {
	private signItConnectService = inject(SignItConnectionFlowService);
	isConnected_ = this.signItConnectService.isSignItConnected_;
}
